import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { PipelineDashboardComponent } from './pipeline-dashboard/pipeline-dashboard.component';
import { ButtonModule, CardModule, FormModule, GridModule, DateRangePickerModule, ButtonGroupModule, LoadingButtonModule, ModalModule, SpinnerModule } from '@coreui/angular-pro';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ChartjsModule } from '@coreui/angular-chartjs';
import { AuthInterceptor } from 'src/AuthInterceptor';
import { DatePipe } from '@angular/common';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { DefaultComponent } from './default/default.component';
import { Shared1Module } from './shared/shared.module';

@NgModule({
  declarations: [
    AppComponent,
    PipelineDashboardComponent,
    DefaultComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    ButtonModule,
    ButtonGroupModule,
    LoadingButtonModule,
    CardModule,
    FormModule,
    ModalModule,
    BrowserAnimationsModule,
    GridModule,
    DateRangePickerModule,
    FormsModule,
    ReactiveFormsModule,
    ChartjsModule,
    SpinnerModule,
    Shared1Module,
  ],
  providers: [{
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    },
    DatePipe,
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
